import type { PreferredGame } from './types';

export const MIN_THRESHOLD = 1;
export const MAX_THRESHOLD = 995;

export const MIN_AMOUNT = 5;
export const MAX_AMOUNT = 1000;

export const MIN_MONTHLY_CAP = 10;
export const MAX_MONTHLY_CAP = 1000;

export const STRIPE_MIN = 1;

export const CONTEXT_SWITCH_DURATION_MS = 600;

export const AccessLevel = {
  STANDARD: 'standard',
  FULL: 'full',
  ADMIN: 'admin',
} as const;

export type AccessLevel = (typeof AccessLevel)[keyof typeof AccessLevel];

export const PreferencesFields = {
  SESSION_LENGTH: 'session_length',
  SESSION_COOLDOWN_DURATION: 'session_cooldown_duration',
  IMAGE_GEN: 'image_gen',
  VIDEO_GEN: 'video_gen',
  PREFERRED_GAMES: 'preferred_games',
  GAMES_ONLY_ALLOWED: 'games_only_allowed',
} as const;

export const PREFERRED_GAMES_DEFAULT: PreferredGame[] = [
  'quiz',
  'odd_word_out',
  'odd_picture_out',
  'caption_match',
  'category_sort',
  'sequence_order',
  'jigsaw_puzzle',
  'memory_match',
  'letter_tracing',
  'gap_fill',
  'pronunciation',
  'clue_detective',
];

export const isPreferredGame = (value: unknown): value is PreferredGame =>
  PREFERRED_GAMES_DEFAULT.includes(value as PreferredGame);

export const SESSION_LENGTH_MIN_MINUTES = 5;
export const SESSION_LENGTH_MAX_MINUTES = 120;
export const SESSION_LENGTH_DEFAULT_MINUTES = 15;
export const SESSION_COOLDOWN_DURATION_DEFAULT_MINUTES = 10;

export const MIN_AGE = 2;
export const MAX_AGE = 100;

export const READING_STAGES = {
  NOT_YET: 'not_yet',
  LEARNING: 'learning',
  INDEPENDENT: 'independent',
} as const;

export type ReadingStage = (typeof READING_STAGES)[keyof typeof READING_STAGES];

export const MODE_INVITE = {
  SHARE: 'share',
  REQUEST: 'request',
} as const;

export const STATUS_INVITES = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REVOKED: 'revoked',
} as const;

export const GrantStatus = {
  ACTIVE: 'active',
  REVOKED: 'revoked',
} as const;

export type GrantStatus = (typeof GrantStatus)[keyof typeof GrantStatus];

export const BtnKey = {
  SHARE: 'share',
  REQUEST: 'request',
  JOIN_BY_CODE: 'joinByCode',
} as const;

export const PROFILE_ACCESS_INVALIDATED_EVENT = 'profile-access-invalidated';
export const GRANTS_REFRESH_EVENT = 'grants-refresh';
